import React from 'react'
import { Link } from 'react-router-dom';

import { Container, Grid, Button, Typography, Box, List, Rating , ListItem } from '@mui/material';
import {useTheme, useMediaQuery } from '@mui/material';
import bg from '../assests/images/bg.jpg';
import abushadi from '../assests/images/abushadi-2.png';
import chef from '../assests/images/young-smiling-male-chef-posing-e1690386747163.jpg';
import chef1 from '../assests/images/chef3.jpg';
import chef2 from '../assests/images/chef4.jpg';
import chef5 from '../assests/images/chef5.jpg';
import chef6 from '../assests/images/chef6.jpg';
import chef8 from '../assests/images/chefAdel.jpeg';
import img1 from '../assests/images/lebnah.jpg';

import img2 from '../assests/images/kebaba.jpg';
import img3 from '../assests/images/idam2.jpg';
import img4 from '../assests/images/salmon.jpg';
import img5 from '../assests/images/wings.jpg';
import img6 from '../assests/images/burger.jpg';
import img7 from '../assests/images/croissants.jpg';
import img8 from '../assests/images/croissants2.jpg';
import img9 from '../assests/images/croissants3.jpg';
import img10 from '../assests/images/pasta.jpg';
import img11 from '../assests/images/table.jpg';
import img12 from '../assests/images/salad7.jpg';
import img13 from '../assests/images/hummus3.jpg';
import img14 from '../assests/images/sand.jpg';
import img15 from '../assests/images/mahshi.jpg';
import img16 from '../assests/images/lamb.jpg';
import img17 from '../assests/images/soup.jpg';
import img18 from '../assests/images/shank.jpg';
import img19 from '../assests/images/crispy.jpg';
import img20 from '../assests/images/raw.jpg';



import CardMedia from '@mui/material/CardMedia';


export default function About() {
  const theme = useTheme();
  const isSmUp = useMediaQuery(theme.breakpoints.up('sm'));
  return (
    <div>
     

    <Grid container 
    sx={{
  
        display: 'flex',
        padding: isSmUp? '2rem 4rem' : "2rem 2rem" 
        
    }}
    >
        <Grid 
        container
        >

        <Grid 
        item
        xs={12}
        md={6}
        sx={{
                 display: 'flex',
                 flexDirection: 'column',
                 justifyContent: 'center'
                
                }}
        >
        <Typography component="h6" variant="h6" align="start" mb={1} className='heading' >
        Chef de cuisine
         </Typography>
         <Typography component="h3" variant="h3" align="start" mb={1} className='sub-heading' >
         Over a Decade of Mastering Diverse Cuisines
         </Typography>
         <Typography component="p" variant="p" align="start" mb={1} className='body' >
         I’m Adel Aljaadi, a passionate and skilled General Chef with over 13 years of global culinary experience. My journey, which began in 2011, has taken me across Italy, France, the Middle East, and Turkey, where I’ve honed my craft under world-renowned chefs. Whether it's mastering Italian cuisine or reviving a restaurant from the brink of closure, I’m driven by my love for food, innovation, and excellence.         </Typography>
         <Link to="https://firebasestorage.googleapis.com/v0/b/knowledgeplus-81caf.appspot.com/o/files%2FCV-Chef-Adel.pdf?alt=media&token=cb81cb38-1064-4bfa-9c9b-482fa863b7a0" target='_blank' class="button-48" style={{marginTop: '2rem'}} role="button"><span class="text">View Resume</span></Link>

        </Grid>

        <Grid 
        item
        xs={12}
        md={6}
        sx={{
            display: 'flex',
            justifyContent: 'center'
        }}
        >
      
       <CardMedia
    component="img"  // This tells CardMedia to act like an img element
    alt="Chef Abu Shadi" 
    image={chef5} 
    sx={{ 
      width: { md: 500, sm: '100%' },
      height: 'auto' // Ensure the height adjusts automatically
    }} 
  />
        </Grid>
        </Grid>
            <Grid
            container 
            marginTop="4rem"
            >
                <Grid item
                xs={12}
                md={4}
                sx={{
                    display: 'flex',
                    justifyContent: 'center'
                }}
                >
                

                    <CardMedia
    component="img"  // This tells CardMedia to act like an img element
    alt="Chef Abu Shadi" 
    src={img5}
    sx={{ 
      width: { md: 350, xs: 250 },
      height: 'auto' // Ensure the height adjusts automatically
    }} 
  />


                </Grid>

                <Grid item
                xs={12}
                md={4}
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                   
                }}
                >
                 

                    <CardMedia
                  component="img"  // This tells CardMedia to act like an img element
                  alt="Chef Abu Shadi" 
                  src={img9}
                  sx={{ 
                    width: { md: 350, xs: 250 },
                    height: 'auto', // Ensure the height adjusts automatically
                  paddingTop: isSmUp ? '6rem' : '2rem'
                  }} 
                />

                </Grid>

                <Grid item
                xs={12}
                md={4}
                sx={{
                    display: 'flex',
                    justifyContent: 'center'
                }}
                >
                    <CardMedia
                component="img"  // This tells CardMedia to act like an img element
                alt="Chef Abu Shadi" 
                src={img10}
                sx={{ 
                  width: { md: 210, xs: 150 },
                  height: 'auto' ,// Ensure the height adjusts automatically
                  paddingTop: isSmUp ? '10rem' : '2rem'
                }} 
              />
                </Grid>
                <Grid item
                xs={12}
                md={12}
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding:3
                }}
                >
                    <CardMedia
                  component="img"  // This tells CardMedia to act like an img element
                  alt="Chef Abu Shadi" 
                  src={img11}
                  sx={{ 
                    width: { md: 400, xs: 300 },
                    height: 'auto' // Ensure the height adjusts automatically
                  }} 
                />

                </Grid>

            </Grid>
      
    </Grid>
    <Grid 
      container 
      component="main" 
      
      sx={{
        backgroundImage: `url(${bg})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        padding: isSmUp? '2rem 4rem' : "2rem 2rem" 

      }}
    >
      {/* Background overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: '#fceade',
          opacity: 0.8,
          zIndex: 1,
        }}
      />

      <Grid 
        item 
        xs={12} 
        sm={12} 
        md={6}
        sx={{
          zIndex: 2, // Ensure it's on top of the overlay
          display: 'flex',
        flexDirection: 'column',
          padding: 3
        }}
      >
        <Typography component="h6" variant="h6" align="start" mb={1} className='heading' >
        My Culinary Journey
        
        </Typography>
        <Typography component="p" variant="p" align="start" mb={1} className='body' >
        Growing up in a family where the art of cooking was cherished, my passion for food was ignited at an early age. This love for culinary arts led me to embark on a unique journey, traveling across Italy, France, Canada, and Turkey, learning from the finest chefs in the world. These experiences not only expanded my expertise across various cuisines—Italian, French, Middle Eastern, and Turkish—but also taught me the importance of creativity, quality, and precision in every dish I create.

Throughout the years, I’ve become not just a chef, but also a leader, guiding restaurants toward success through comprehensive management, staff training, and waste reduction strategies.
        
        </Typography>
        
      </Grid>
      <Grid 
        item 
        xs={12} 
        sm={12} 
        md={6}
        sx={{
          zIndex: 2, // Ensure it's on top of the overlay
          display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
          
        }}
      >
        <img src={chef1} style={{width: '300px'}} alt="" />
      </Grid>

      
    </Grid>

    <Grid
    container
    sx={{
      padding: isSmUp? '2rem 4rem' : "2rem 2rem" 
          
        
      }}
    >
        <Grid
        item
        sm={12} 
        md={6}
        sx={{
          
            display: 'flex',
          flexDirection: 'column',
      padding:3
            
          }}
        >
            <Typography component="h6" variant="h6" align="start" mb={1} className='heading' >
            Culinary Philosophy
        
        </Typography>
        <Typography component="p" variant="p" align="start" mb={1} className='body' >
        For me, cooking is more than just preparing a meal—it's about telling a story through flavors and experiences. My culinary philosophy revolves around three key principles: innovation, sustainability, and quality. I believe in constantly pushing boundaries to create dishes that are as beautiful as they are delicious.

A major part of my work is reducing waste and ensuring sustainability. I’ve successfully implemented strategies that have brought restaurant waste to below 0%, turning potential losses into profits. Whether it's baking fresh bread daily or creating a new signature dish, my goal is always the same: to deliver culinary excellence while fostering a sustainable future.
        </Typography>

        </Grid>
        <Grid 
        item 
        xs={12} 
        sm={12} 
        md={6}
        sx={{
          zIndex: 2, // Ensure it's on top of the overlay
          display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
          padding:3
        }}
      >
        <CardMedia
                  component="img"  // This tells CardMedia to act like an img element
                  alt="Chef Abu Shadi" 
                  src={chef2}
                  sx={{ 
                    width: { md: 500, xs: 350 },
                    height: 'auto' // Ensure the height adjusts automatically
                  }} 
                />
      </Grid>

      <Grid container 
        mt={5}
        xs={12} 
        sm={12} 
        md={8}
      >
      <Grid 
        item 
        xs={12} 
        sm={12} 
        md={4}
        sx={{
          zIndex: 2, // Ensure it's on top of the overlay
          display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
          
        }}
      >
        <img src={img12} style={{width: '200px', marginBottom: '2rem'}} alt="" />
        <CardMedia
                  component="img"  // This tells CardMedia to act like an img element
                  alt="Chef Abu Shadi" 
                  src={img13}
                  sx={{ 
                    width: 200,
                    height: 'auto' ,
                    marginBottom: {xs:'2rem', md:''}
                  }} 
                />

      </Grid>
      <Grid 
        item 
        xs={12} 
        sm={12} 
        md={4}
        sx={{
          zIndex: 2, // Ensure it's on top of the overlay
          display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
          
        }}
      >
        <img src={img16} style={{width: '300px', marginBottom: '2rem', }} alt="" />

      </Grid>
      <Grid 
        item 
        xs={12} 
        sm={12} 
        md={4}
        sx={{
          zIndex: 2, // Ensure it's on top of the overlay
          display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
          
        }}
      >
        <img src={img15} style={{width: '200px', marginBottom: '2rem'}} alt="" />
        <img src={img14} style={{width: '200px'}} alt="" />

      </Grid>
      

      </Grid>

        <Grid 
        container
            mt={5}
            xs={12} 
            sm={12} 
            md={8}
        >

        </Grid>
    </Grid>

    <Grid 
      container 
      component="main" 
      
      sx={{
        backgroundImage: `url(${bg})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        position: 'relative',
        padding: isSmUp? '2rem 4rem' : "2rem 2rem" 


      }}
    >
      {/* Background overlay */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: '#fceade',
          opacity: 0.8,
          zIndex: 1,
        }}
      />

      <Grid 
        item 
        xs={12} 
        sm={12} 
        md={6}
        sx={{
          zIndex: 2, // Ensure it's on top of the overlay
          display: 'flex',
        flexDirection: 'column',
        padding: 3
          
        }}
      >
        <Typography component="h6" variant="h6" align="start" mb={1} className='heading' >
        Global Expertise & Achievements
        
        </Typography>
        <Typography component="p" variant="p" align="start" mb={1} className='body' >
        Over the past decade, I’ve had the privilege of leading multiple restaurants to success. From establishing nine branches of Al-Jawad Restaurant in Lebanon to transforming Loaded Kumpir in Malaysia into a trending hotspot, my work speaks for itself. I specialize in turning struggling restaurants into profitable ventures by introducing innovative menus, maximizing profits, and implementing efficient management strategies.

As an expert in Italian, French, Middle Eastern, and Turkish cuisines, I’m proud to bring the flavors of the world to every dish I create. My experience ranges from crafting authentic Italian pizza and pasta dishes to introducing modern twists on Middle Eastern classics, all while maintaining the highest standards of quality and taste.
        </Typography>
      </Grid>
      <Grid 
        item 
        xs={12} 
        sm={12} 
        md={6}
        sx={{
          zIndex: 2, // Ensure it's on top of the overlay
          display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
          
        }}
      >
        <img src={chef6} style={{width: '300px'}} alt="" />
      </Grid>

      
    </Grid>

    <Grid container 
    sx={{
  
        display: 'flex',
        padding: isSmUp? '2rem 4rem' : "2rem 2rem" 
        
    }}
    >
        <Grid container
      sx={{    
      }}  
        >

        <Grid 
        item
        xs={12}
        md={6}
        sx={{
                 display: 'flex',
                 flexDirection: 'column',
                 justifyContent: 'center',
                padding: 3
                }}
        >
        <Typography component="h6" variant="h6" align="start" mb={1} className='heading' >
        Restaurant Management Expertise
        
         </Typography>
         {/* <Typography component="h3" variant="h3" align="start" mb={1} className='sub-heading' >
         Over a Decade of Mastering Diverse Cuisines
         </Typography> */}
         <Typography component="p" variant="p" align="start" mb={1} className='body' >
         My expertise goes beyond the kitchen. As a restaurant manager, I’ve developed a deep understanding of how to run a successful, profitable business. From cost calculation and staff training to menu creation and waste management, I know how to optimize every aspect of a restaurant. My approach has allowed me to reduce waste to below 0% while increasing profits, and I’ve helped restaurants across the globe thrive in highly competitive markets.         
          </Typography>
        </Grid>

        <Grid 
        item
        xs={12}
        md={6}
        sx={{
            display: 'flex',
            justifyContent: 'center',
            padding:3
        }}
        >
       <CardMedia
                  component="img"  // This tells CardMedia to act like an img element
                  alt="Chef Abu Shadi" 
                  src={chef8}
                  sx={{ 
                    width: { md: 500, xs: 300 },
                    height: 'auto' // Ensure the height adjusts automatically
                  }} 
                />
        </Grid>
        </Grid>
            <Grid
            container 
            marginTop="4rem"
            >
                <Grid item
                xs={12}
                md={4}
                sx={{
                    display: 'flex',
                    justifyContent: 'center'
                }}
                >
                   
                    <CardMedia
                  component="img"  // This tells CardMedia to act like an img element
                  alt="Chef Abu Shadi" 
                  src={img17}
                  sx={{ 
                    width: { md: 350, xs: 250 },
                    height: 'auto' // Ensure the height adjusts automatically
                  }} 
                />

                </Grid>

                <Grid item
                xs={12}
                md={4}
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                   
                }}
                >

                    <CardMedia
                  component="img"  // This tells CardMedia to act like an img element
                  alt="Chef Abu Shadi" 
                  src={img18}
                  sx={{ 
                    width: { md: 380, xs: 280 },
                    height: 'auto', // Ensure the height adjusts automatically
                    paddingTop: '6rem'
                  }} 
                />
                </Grid>

                <Grid item
                xs={12}
                md={4}
                sx={{
                    display: 'flex',
                    justifyContent: 'center'
                }}
                >

                    <CardMedia
                  component="img"  // This tells CardMedia to act like an img element
                  alt="Chef Abu Shadi" 
                  src={img19}
                  sx={{ 
                    width: { md: 290, xs: 250 },
                    height: 'auto', // Ensure the height adjusts automatically
                    paddingTop: '10rem'
                  }} 
                />

                </Grid>
                <Grid item
                xs={12}
                md={12}
                sx={{
                    display: 'flex',
                    justifyContent: 'center'
                }}
                >
                    <CardMedia
                  component="img"  // This tells CardMedia to act like an img element
                  alt="Chef Abu Shadi" 
                  src={img20}
                  sx={{ 
                    width: { md: 480, xs: 280 },
                    height: 'auto', // Ensure the height adjusts automatically
                    paddingTop: '3rem'
                  }} 
                />

                </Grid>

            </Grid>
      
    </Grid>

    </div>
  )
}
